import { useEffect } from "react";

export enum KeydownHandlerKeyEnum {
  ESC = "Escape",
}

const useKeydownHandler = (
  key: KeydownHandlerKeyEnum | string,
  handler?: () => void
) => {
  useEffect(() => {
    if (!handler) {
      return () => {};
    }

    const keyDownHandler = (event: KeyboardEvent) => {
      if (event.key === key) {
        handler();
      }
    };

    // Not passive: `passive` only ever helps scroll-blocking events (touch,
    // wheel), and a passive keydown listener turns any preventDefault reached
    // during its dispatch into a console error.
    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [handler, key]);
};

export default useKeydownHandler;
